import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { getErrorData } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
export default {
  name: "DefaultDeparturesComponent",
  components: {
    Confirm: Confirm
  },
  props: {
    continent: Object,
    listCountries: Array,
    listStates: Array,
    warehouses: Array,
    defaultsDepartures: Array
  },
  data: function data() {
    return {
      continentDefaultDepartureId: null,
      continentWarehouseIdOrigin: null,
      continentWarehouseId: null,
      isSavingDefaultDeparture: false,
      countriesWarehouse: [],
      statesWarehouse: [],
      isShowExistingCountries: true,
      isShowExistingStates: true,
      addDefaultDepartureToken: null,
      isAdding: false,
      form: {
        continentIso2: null,
        countryId: null,
        stateId: null,
        warehouseId: null
      },
      displayedListStates: [],
      managedExceptions: {
        error: {
          default_departure_already_exists: "The departure already exists"
        }
      }
    };
  },
  computed: {
    displayedStatesList: function displayedStatesList() {
      var _this2 = this;
      var displayedListStates = [];
      if (this.form.countryId && this.listCountries.some(function (x) {
        return x.id_country == _this2.form.countryId;
      })) {
        for (var state in this.listStates) {
          if (this.listStates[state].id_country === this.form.countryId) {
            displayedListStates.push(this.listStates[state]);
          }
        }
      }
      return displayedListStates;
    },
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        return !x.countryId || !x.warehouseId;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    }
  },
  created: function created() {
    var _this$continent;
    this.form.continentIso2 = (_this$continent = this.continent) === null || _this$continent === void 0 ? void 0 : _this$continent.iso;
    this.loadDepartures();
  },
  methods: {
    loadDepartures: function loadDepartures() {
      var _this3 = this;
      this.defaultsDepartures.forEach(function (x) {
        if (x.countryId == null && x.stateId == null) {
          _this3.continentDefaultDepartureId = x.id;
          _this3.continentWarehouseIdOrigin = x.warehouseId;
          _this3.continentWarehouseId = x.warehouseId;
        } else if (x.stateId == null) {
          _this3.countriesWarehouse.push(_objectSpread(_objectSpread({}, x), {}, {
            warehouseName: _this3.warehouses.find(function (y) {
              return y.id_warehouse == x.warehouseId;
            }).name,
            countryName: _this3.listCountries.find(function (y) {
              return y.id_country == x.countryId;
            }).printable_name,
            isChanging: false
          }));
        } else {
          _this3.statesWarehouse.push(_objectSpread(_objectSpread({}, x), {}, {
            warehouseName: _this3.warehouses.find(function (y) {
              return y.id_warehouse == x.warehouseId;
            }).name,
            countryName: _this3.listCountries.find(function (y) {
              return y.id_country == x.countryId;
            }).printable_name,
            stateName: _this3.listStates.find(function (y) {
              return y.id_state == x.stateId;
            }).state_label,
            isChanging: false
          }));
        }
      });
      this.countriesWarehouse.sort(function (a, b) {
        return a.countryName.localeCompare(b.countryName);
      });
      this.statesWarehouse.sort(function (a, b) {
        return a.stateName.localeCompare(b.stateName);
      });
    },
    updateContinentDeparture: function updateContinentDeparture() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this4.continentWarehouseId) {
                _context.next = 6;
                break;
              }
              _this4.isSavingDefaultDeparture = true;
              data = {
                Id: _this4.continentDefaultDepartureId,
                ContinentIso2: _this4.form.continentIso2,
                WarehouseId: _this4.continentWarehouseId
              };
              _this = _this4;
              _context.next = 6;
              return request("/v1/warehouse/defaults-departures/save", data.Id ? "put" : "post", data, true, "api").then(function (_) {
                _this.$toasted.show("Continent departure has been successfully updated", {
                  type: "success"
                });
                _this.continentWarehouseIdOrigin = _this4.continentWarehouseId;
                _this.$emit("reloaded");
                _this.isSavingDefaultDeparture = false;
              }).catch(function (e) {
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to save continent default departure");
                _this.$toasted.show(errorData.message, {
                  type: errorData.type
                });
                _this.isSavingDefaultDeparture = false;
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    toggleShowCountries: function toggleShowCountries() {
      this.isShowExistingCountries = !this.isShowExistingCountries;
    },
    toggleShowStates: function toggleShowStates() {
      this.isShowExistingStates = !this.isShowExistingStates;
    },
    updateDeparture: function updateDeparture(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(item.warehouseId != null)) {
                _context2.next = 5;
                break;
              }
              item.isChanging = true;
              _this = _this5;
              _context2.next = 5;
              return request("/v1/warehouse/default-departure/".concat(item.id), "put", {
                warehouseId: item.warehouseId
              }, true, "api", null).then(function (_) {
                _this.$toasted.show("Departure has been successfully updated", {
                  type: "success"
                });
                item.isChanging = false;
                _this.$emit("reloaded");
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the default departure.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  item.isChanging = false;
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    deleteDeparture: function deleteDeparture(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.$refs.confirm.open("Delete precision", "Are you sure you want to delete the precision for \"".concat(item.countryName).concat(item.stateId ? ", ".concat(item.stateName) : "", "\" ?"), {
                color: "warning"
              });
            case 2:
              confirmed = _context3.sent;
              if (!confirmed) {
                _context3.next = 8;
                break;
              }
              item.isChanging = true;
              _this = _this6;
              _context3.next = 8;
              return request("/v1/warehouse/default-departure/".concat(item.id), "delete", _this6.form, true, "api", null, _this6.addDefaultDepartureToken).then(function (_) {
                if (item.stateId) {
                  _this.statesWarehouse.splice(_this.statesWarehouse.indexOf(item), 1);
                } else {
                  _this.countriesWarehouse.splice(_this.countriesWarehouse.indexOf(item), 1);
                }
                _this.$emit("reloaded");
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to remove the default departure.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  item.isChanging = false;
                }
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addDeparture: function addDeparture() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this7$addDefaultDepa;
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this7.isAdding = true;
              (_this7$addDefaultDepa = _this7.addDefaultDepartureToken) === null || _this7$addDefaultDepa === void 0 || _this7$addDefaultDepa.cancel();
              _this7.addDefaultDepartureToken = axios.CancelToken.source();
              _this = _this7;
              _context4.next = 6;
              return request("/v1/warehouse/default-departure", "post", _this7.form, true, "api", null, _this7.addDefaultDepartureToken).then(function (response) {
                if (_this.form.stateId) {
                  _this.statesWarehouse.push(_objectSpread(_objectSpread({}, _this.form), {}, {
                    id: response.data.value,
                    warehouseName: _this.warehouses.find(function (y) {
                      return y.id_warehouse == _this.form.warehouseId;
                    }).name,
                    countryName: _this.listCountries.find(function (y) {
                      return y.id_country == _this.form.countryId;
                    }).printable_name,
                    stateName: _this.listStates.find(function (y) {
                      return y.id_state == _this.form.stateId;
                    }).state_label,
                    isChanging: false
                  }));
                  _this.statesWarehouse.sort(function (a, b) {
                    return a.stateName.localeCompare(b.stateName);
                  });
                } else {
                  _this.countriesWarehouse.push(_objectSpread(_objectSpread({}, _this.form), {}, {
                    id: response.data.value,
                    warehouseName: _this.warehouses.find(function (y) {
                      return y.id_warehouse == _this.form.warehouseId;
                    }).name,
                    countryName: _this.listCountries.find(function (y) {
                      return y.id_country == _this.form.countryId;
                    }).printable_name,
                    isChanging: false
                  }));
                  _this.countriesWarehouse.sort(function (a, b) {
                    return a.countryName.localeCompare(b.countryName);
                  });
                }
                _this.$emit("reloaded");
              }).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to create the default departure.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                }
              });
            case 6:
              _this7.isAdding = false;
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};